import { t_key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { APCourse, IAPCourseMeta } from '../builders/ap_course_builder';
import { APCourseGroup } from '../builders/ap_course_group_builder';
import {
  APProgramSlot,
  APProgramSlotBuilder,
  IAPProgramSlotMeta,
  ProgramSlot
} from '../builders/ap_program_slot_builder';
import { APProgramSlotServant } from '../servants/ap_program_slot_servant';
import { IAPCoursesDatasource } from './ap_courses_datasource';
import { IAPGradeConfigsDatasource } from './ap_gradeconfigs_datasource';
import { IAPPlannedCourseDataSource } from './ap_planned_course_datasource';
import { IAPPlannedCourseGroupDatasource } from './ap_planned_course_group_datasource';
export interface IAPProgramSlotDatasource extends IDatasource<APProgramSlot, {}, IAPProgramSlotMeta> {}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'ngAPProgramSlotDatasource',
    (
      ngAPCoursesDatasource: IAPCoursesDatasource,
      ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
      ngAPPlannedCourseGroupDatasource: IAPPlannedCourseGroupDatasource,
      ngAPGradeConfigsDatasource: IAPGradeConfigsDatasource
    ) => {
      return new Datasource<APProgramSlot, {}, IAPProgramSlotMeta>({
        builderType: APProgramSlotBuilder,
        updateMode: 'merge'
      }).includeMetasource<IAPProgramSlotMeta>((datasource: any) => {
        return new Metasource<APProgramSlot, IAPProgramSlotMeta>(datasource)
          .includeAttributes((programSlot) => {
            if (!APProgramSlotServant.isNCRProgramSlot(programSlot)) {
              const courseIds = _4.map(programSlot.courses, (c) => c['course_id']);
              return {
                _course_ids: courseIds,
                _courses: ngAPCoursesDatasource.cursor(courseIds),
                _course_group: _4.find(ngAPPlannedCourseGroupDatasource.read(), { program_slot: programSlot.id })
              };
            } else {
              return {
                _course_group: _4.find(ngAPPlannedCourseGroupDatasource.read(), { program_slot: programSlot.id })
              };
            }
            // }
          })
          .includeAttribute('_grade_config', () => {
            return _4.first(ngAPGradeConfigsDatasource.values());
          })
          .includeAttribute('_term_id', (programSlot: any) => {
            let course: any;
            course = _4.find(
              ngAPPlannedCoursesDatasource.read(),
              (plannedCourse: any) => plannedCourse.program_slot === programSlot.id
            );
            if (!course) {
              course = _4.find(
                ngAPPlannedCourseGroupDatasource.read(),
                (plannedCourseGroup: any) => plannedCourseGroup.program_slot === programSlot.id
              );
            }
            return course ? course.term : undefined;
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/datasources/ap_program_slot_datasource.ts